import * as React from 'react';
import { addClass, Bem } from '../../utils/css.js';
import { Size } from '../../constants.js';
import './InputField.scss.js';
import { useId } from '../../utils/hooks/useId.js';

const bem = Bem.create("vai-input-field");
const InputField = React.forwardRef(function InputField2(props, ref) {
  const { innerRef, htmlId, invalid, width = Size.M, type = "text", dataTa, unitLabel, className, endIcon, disabled, ...rest } = props;
  const id = useId(htmlId, ["input field"]);
  return /* @__PURE__ */ React.createElement("div", {
    id: id.toString(),
    "data-ta": dataTa,
    className: addClass(bem.block(), className),
    ref
  }, endIcon ? /* @__PURE__ */ React.createElement("div", {
    className: bem.element("wrapper")(width)
  }, /* @__PURE__ */ React.createElement("input", {
    id: id.copyWith(["input"]).toString(),
    className: bem.element("input")(invalid && "invalid", width),
    ref: innerRef,
    type,
    style: { paddingRight: "24px" },
    disabled,
    ...rest
  }), /* @__PURE__ */ React.createElement("div", {
    className: bem.element("icon")(disabled && "disabled")
  }, endIcon)) : /* @__PURE__ */ React.createElement("input", {
    id: id.copyWith(["input"]).toString(),
    className: bem.element("input")(invalid && "invalid", width),
    ref: innerRef,
    type,
    disabled,
    ...rest
  }), unitLabel && /* @__PURE__ */ React.createElement("span", {
    className: bem.element("unit-label")()
  }, unitLabel));
});
InputField.metaProperties = ["invalid", "disabled"];

export { InputField };
